<template>
  <v-overlay
    v-model="imageFocusDialogOpen"
    class="image-dialog-overlay"
  >
    <v-dialog
      v-model="imageFocusDialogOpen"
      :scrim="false"
    >
      <v-card :title="imageFocus?.title">
        <template #title>
          {{ imageFocus?.title }}
        </template>

        <template #subtitle>
          {{ imageFocus?.description }}
        </template>

        <v-img
          :src="imageFocusSrc"
        >
          <template #placeholder>
            <div class="img-placeholder-bg d-flex align-center justify-center fill-height">
              <v-progress-circular
                color="grey-lighten-4"
                indeterminate
              />
            </div>
          </template>
        </v-img>
      </v-card>
    </v-dialog>
  </v-overlay>
</template>

<script setup lang="ts">
const imageFocusDialogStore = useImageFocusDialogStore();
const { imageFocusSrc, imageFocus, imageFocusDialogOpen } = storeToRefs(imageFocusDialogStore);
</script>

<style scoped>
.img-placeholder-bg {
  background: rgba(0, 0, 0, 0.2)
}
</style>
